<template>
  <div class="exam-uniform-batch-date-range">
    <el-date-picker v-model="inputDate"
                    type="daterange"
                    range-separator="至"
                    unlink-panels
                    prefix-icon="el-icon-date"
                    value-format="yyyy-MM-dd"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"></el-date-picker>
  </div>
</template>

<script>
export default {
  name: 'ExamUniformBatchDateRange',
  props: {
    value: String,
    formData: Object,
    dateKey: {
      type: String,
      required: true
    }
  },
  computed: {
    inputDate: {
      get () {
        if (this.value) {
          return this.value.split(',')
        } else {
          return []
        }
      },
      set (val) {
        if (val && val.length) {
          this.$emit('input', val.join(','))
        } else {
          this.$emit('input', '')
        }
      }
    }
  },
  watch: {
    formData: {
      handler (val) {
        if (val) {
          const date = val[`${this.dateKey}Date`]
          if (date) {
            this.inputDate = date.split('至')
          }
        }
      },
      immediate: true,
      deep: true
    }
  }
}
</script>

<style lang="scss">
  .exam-uniform-batch-date-range {
    .el-date-editor {
      max-width: 100%!important;
      width: 320px!important;
    }
  }
</style>
